export default __webpack_public_path__ + "static/img-HR-51db9cd4a599bf70a54543103c49423e.png";